module.exports = __webpack_public_path__ + "img/images.74c8e8fb.jpg";